import { createApiClient } from '@aimsos/api-client';
import { tokenService } from '@aimsos/auth';

function makeClient(envKey) {
  const rawBase = import.meta.env[envKey] || '';
  const baseURL = rawBase.replace(/\/+$/, '');
  return createApiClient({
    baseURL,
    getToken: () => tokenService.getToken(),
    refreshToken: async () => {
      const userUuid = localStorage.getItem('user_uuid') || undefined;
      const tenantUuid = localStorage.getItem('workspace_uuid') || undefined;
      return tokenService.refreshToken(userUuid, tenantUuid);
    },
  });
}

export const { client: api, setToken } = makeClient('VITE_API_BASE_URL');
export const { client: apiWS } = makeClient('VITE_API_BASE_URL_WS');
export const { client: apiAuth } = makeClient('VITE_API_BASE_URL_AUTH');
